export const tabs = {
  lotto: [],
  cardGames: [],
  roulette: [],
  popular: ['the_epic_win_x125', 'zeus_the_thunderer'],
  nuevo: [
    'the_epic_win_x125',
    'zeus_the_thunderer',
    'the_biggest_win_x50',
    'zeus_the_invincible',
    'the_dawn_is_coming',
    'spicy_candies_rockblocks',
  ],
};

const sectionIdsMap = {
  mascot: 'mascotGaming',
  ttt: 'ttt',
};

export const getSlotImage = (slotId, sectionId) =>
  `https://static.mascot.games/${sectionIdsMap[sectionId] || sectionId}/assets/promo/icons/games/300x300/${String(
    slotId,
  ).toLowerCase()}.png`;

export const getTab = (slotId, slotName) => {
  const matchedTabs = Object.keys(tabs).reduce((acc, tab) => {
    return tabs[tab].includes(String(slotId)) ? [...acc, tab] : acc;
  }, []);

  if (slotName.toLowerCase().includes('megaways')) {
    matchedTabs.push('megaways');
  }

  return Array.from(new Set(matchedTabs));
};
